// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__j82yM","modalBody":"ConfirmationPop_modalBody__Fnx5G"};